import { formatPeriod, isCurrentPeriod, isPartialPeriod, nextPeriods } from './period';

export const FORECAST_PERIODS = 3;

export const linearTrend = (values, forecastCount = FORECAST_PERIODS) => {
  const points = values.map((y, x) => [x, y]).filter(([, y]) => y !== null && y !== undefined);
  if (points.length < 2) return null;

  const n = points.length;
  const sumX = points.reduce((sum, [x]) => sum + x, 0);
  const sumY = points.reduce((sum, [, y]) => sum + y, 0);
  const sumXY = points.reduce((sum, [x, y]) => sum + x * y, 0);
  const sumXX = points.reduce((sum, [x]) => sum + x * x, 0);

  const slope = (n * sumXY - sumX * sumY) / (n * sumXX - sumX * sumX);
  const intercept = (sumY - slope * sumX) / n;
  const at = (x) => Math.max(0, intercept + slope * x);

  return {
    slope,
    trend: values.map((_, x) => at(x)),
    forecast: Array.from({ length: forecastCount }, (_, i) => at(values.length + i)),
  };
};

export const buildChartRows = (points, granularity, { unique = false, today = new Date() } = {}) => {
  if (!points?.length) return { rows: [], total: 0, slope: null };

  const rows = points.map((point) => ({
    period: point.period,
    label: formatPeriod(point.period, granularity),
    value: unique ? point.unique_value ?? 0 : point.value,
    inProgress: isCurrentPeriod(point.period, granularity, today),
    partial: isPartialPeriod(point.period),
  }));

  const fit = linearTrend(rows.map((row) => (row.inProgress || row.partial ? null : row.value)));
  const total = rows.reduce((sum, row) => sum + row.value, 0);
  if (!fit) return { rows, total, slope: null };

  rows.forEach((row, i) => {
    row.trend = fit.trend[i];
  });
  rows[rows.length - 1].forecast = fit.trend[rows.length - 1];

  const future = nextPeriods(rows[rows.length - 1].period, granularity, fit.forecast.length).map((period, i) => ({
    period,
    label: formatPeriod(period, granularity),
    forecast: fit.forecast[i],
  }));

  return { rows: [...rows, ...future], total, slope: fit.slope };
};
